import React from "react";
import { data } from "./data/portfolio";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Education from "./components/Education";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./styles/global.css";

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero data={{ name: data.name, role: data.role, tagline: data.tagline }} />
        <About data={{ about: data.about }} />
        <Education data={data.education} />
        <Skills data={data.skills} />
        <Projects data={data.projects} />
        <Contact data={data.contact} />
      </main>
      <Footer name={data.name} />
    </>
  );
}
